import {CART_ADDRESS_INPUT, CHECKOUT_SELECTED_CUSTOMER_ADDRESS, SHIPPING_CART_ADDRESS} from '@/lib/constants';
import {getFirstAndLastNameFromFullName} from '@/_application/core/utils/common';
import {atom} from 'jotai';
import {atomWithStorage} from 'jotai/utils';
import {CartAddressInput, CartAddressRegion, CustomerAddress, ShippingCartAddress} from '../../__generated__/__types__';

export const initialShippingCartAddress: ShippingCartAddress = {
    lastname: '',
    postcode: '',
    firstname: '',
    customer_notes: '',
    country: {
        code: 'VN',
        label: 'VN',
    },
    company: '',
    city: '',
    region: {
        code: '',
        label: '',
    },
    street: [''],
    telephone: '',
    district: undefined,
    district_id: undefined,
    ward_id: undefined,
    ward: undefined,
};

export const selectedCustomerAddressAtom = atomWithStorage<CustomerAddress | null>(
    CHECKOUT_SELECTED_CUSTOMER_ADDRESS,
    null,
);

export const shippingCartAddressAtom = atomWithStorage<ShippingCartAddress>(
    SHIPPING_CART_ADDRESS,
    initialShippingCartAddress,
);

export const cartAddressInputAtom = atom<CartAddressInput | null>(null);

export const clearShippingCartAddressAtom = atom(null, (_get, set, _data) => {
    return set(shippingCartAddressAtom, initialShippingCartAddress);
});

export const cartAddressFullNameAtom = atom(
    get => {
        const {firstname, lastname} = get(shippingCartAddressAtom);
        return firstname ? `${firstname} ${lastname}` : '';
    },
    (get, set, data: string) => {
        const prev = get(shippingCartAddressAtom);
        const [firstname, lastname] = getFirstAndLastNameFromFullName(data);
        return set(shippingCartAddressAtom, {...prev, firstname, lastname});
    },
);

export const cartAddressCityAtom = atom(
    get => get(shippingCartAddressAtom).city,
    (get, set, data: string) => {
        const prev = get(shippingCartAddressAtom);
        return set(shippingCartAddressAtom, {...prev, city: data});
    },
);

export const cartAddressCustomerNotesAtom = atom(
    get => get(shippingCartAddressAtom).customer_notes,
    (get, set, data: string) => {
        const prev = get(shippingCartAddressAtom);
        return set(shippingCartAddressAtom, {...prev, customer_notes: data});
    },
);

export const cartAddressTelephoneAtom = atom(
    get => get(shippingCartAddressAtom).telephone,
    (get, set, data: string) => {
        const prev = get(shippingCartAddressAtom);
        return set(shippingCartAddressAtom, {...prev, telephone: data});
    },
);

export const cartAddressStreetsAtom = atom(
    get => get(shippingCartAddressAtom).street,
    (get, set, data?: string[]) => {
        const prev = get(shippingCartAddressAtom);
        return set(shippingCartAddressAtom, {...prev, street: data || []});
    },
);

export const cartAddressRegionAtom = atom(
    get => get(shippingCartAddressAtom).region,
    (get, set, data: CartAddressRegion) => {
        const prev = get(shippingCartAddressAtom);
        return set(shippingCartAddressAtom, {...prev, region: data});
    },
);

export const cartAddressDistrictIdAtom = atom(
    get => get(shippingCartAddressAtom).district_id,
    (get, set, data?: number) => {
        const prev = get(shippingCartAddressAtom);
        return set(shippingCartAddressAtom, {...prev, district_id: data || 0});
    },
);

export const cartAddressWardIdAtom = atom(
    get => get(shippingCartAddressAtom).ward_id,
    (get, set, data?: number) => {
        const prev = get(shippingCartAddressAtom);
        return set(shippingCartAddressAtom, {...prev, ward_id: data || 0});
    },
);

export const cartAddressWardNameAtom = atom(
    get => get(shippingCartAddressAtom).ward,
    (get, set, data?: string) => {
        const prev = get(shippingCartAddressAtom);
        return set(shippingCartAddressAtom, {...prev, ward: data || 'N/A'});
    },
);

export const cartAddressDistrictNameAtom = atom(
    get => get(shippingCartAddressAtom).district,
    (get, set, data?: string) => {
        const prev = get(shippingCartAddressAtom);
        return set(shippingCartAddressAtom, {...prev, district: data || 'N/A'});
    },
);
